export function getTheme(productType) {
  switch (productType) {
    case 'domain':
      return 'blue';
    case 'mailbox-standalone':
    case 'mailboxv2':
      return 'purple';
    case 'certificate':
      return 'green';
    case 'cloud':
      return 'red';
    case 'paas':
      return 'orange';
    case 'domain_option':
    case 'corporate':
    case 'marketplace':
    case 'tmch':
    default:
      return 'primary';
  }
}